<template>
  <lu-vbox class='app-container svpad-in-20' lu-flex>
   <Spinner ref='spinner' />

    <lu-item>
      <PageHeader :title=' $t("Change of password") ' :hasList='false' :hasReload='false' />
    </lu-item>


    <lu-vbox lu-flex lu-hcenter class='page' style='font-size: 0.9rem; padding: 30px;' >
      <el-form ref='form' :model='form' label-width="180px" sclass='lu-flex lu-flex-wrap'>
          <el-form-item :label='$t("Your password")' prop='oldPwd' :rules="oldPwdRule">
            <el-input type="password" v-model='form.oldPwd' />
          </el-form-item>
          <el-form-item :label='$t("New password")' prop='newPwd' :rules="newPwdRule">
            <el-input type="password" v-model='form.newPwd' />
          </el-form-item>
          <el-form-item :label='$t("Confirm new password")' prop='confirmPwd' :rules="confirmPwdRule">
            <el-input type="password" v-model='form.confirmPwd' />
          </el-form-item>
      </el-form>
      <lu-hbox class='mar-t-10 pad-in-5'>
        <lu-item><el-button class='button' icon='el-icon-check' @click="submitForm()">{{ $t('Change') }}</el-button></lu-item>
        <lu-item><el-button class='button' icon='el-icon-close' @click="returnHome">{{ $t('cancel') }}</el-button></lu-item>
      </lu-hbox>
    </lu-vbox>
  </lu-vbox>
</template>

<script>
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import { mapGetters } from 'vuex'
import PageHeader from '@/components/PageHeader'
import Spinner from '@/components/Spinner'

export default {
  name: 'ChangePassword',
  components: { Spinner, LuVbox, LuHbox, PageHeader, LuItem },
  methods: {
    validatePassword (rule, value, cb) {
      //if (this.form.password2 !== '') {
      if (this.form.confirmPwd!=null && this.form.confirmPwd !== '') {
        this.$refs.form.validateField('confirmPwd')
      }
      cb()
    },
    validateConfirmPassword (rule, value, cb) {
      if (value === '') {
        cb(new Error('Please input the password again'))
      }
      else if (value !== this.form.newPwd) {
        cb(new Error('Passwords does not match!'))
      }
      else {
        cb()
      }
    },
    returnHome: function () {
      // eslint-disable-next-line handle-callback-err
      this.$router.push({ path: '/home' })
    },
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let cond = {
            login: this.userInfos.login,
            oldPwd: this.form.oldPwd,
            password: this.form.newPwd,
            confirmPwd: this.form.confirmPwd
          }
          this.$tango.changePassword(cond).then(rep => {
            if (rep.resultCode === 0) {
              this.$refs.spinner.hide()
              this.$message({
                type: 'success',
                message: this.$t('Password has been successfully changed')
              })
              this.returnHome()
            }
            else {
              throw new Error('Unknown user')
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: err.message
            })
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters([ 'userInfos' ]),
    ...mapGetters('resultMessage', [ 'resultMessage' ])
  },
  data: function () {
    return {
      form: {
        oldPwd: null,
        newPwd: null,
        confirmPwd: null
      },
      oldPwdRule: [{ required: true, message: 'Please input current password', trigger: ['blur', 'change'] }],
      newPwdRule: [
        { validator: this.validatePassword },
        { required: true, message: 'Please input new password', trigger: ['blur', 'change'] }
      ],
      confirmPwdRule: [
        { validator: this.validateConfirmPassword },
        { required: true, message: 'Please input confirm new password', trigger: ['blur', 'change'] }
      ]
    }
  }
}
</script>

<style scoped>
#session {
  margin: 10px;
  padding: 20px;
  max-width: 1200px;
  max-height: 350px;
  border-radius: 4px;
  margin-bottom: 10px;
  color: #FFF;
  border: 1px solid #202020;
}

.page {
  margin: 10px;
  padding: 20px;
border-radius: 4px;
  margin-bottom: 10px;
  color: #FFF;
}
</style>
